import { ReactNode, useEffect } from 'react';
import { useLocation } from 'react-router-dom';

interface PageTransitionProps {
  children: ReactNode;
  className?: string;
}

export function PageTransition({ children, className }: PageTransitionProps) {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return <div className={className}>{children}</div>;
}

export function FadeTransition({ children, className }: PageTransitionProps) {
  return <div className={className}>{children}</div>;
}

export function SlideTransition({ children, className }: PageTransitionProps) {
  return <div className={className}>{children}</div>;
}
